// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { z } from 'zod';
export const testTemplateId = (z.number());
export const testTemplate = z.object({
    id: testTemplateId,
    name: z.string(),
    description: z.string().nullable(),
    category: z.string().nullable(),
    default_assignee_role: z.string().nullable(),
    estimated_duration_hours: z.string().nullable(),
    icon: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    code: z.string(),
    draft_dirty: z.boolean(),
    archived_at: z.date().nullable(),
    archived_by: operatorId.nullable(),
    blueprint: z.string().nullable(),
    blueprint_version: z.number().nullable(),
});
export const testTemplateInitializer = z.object({
    id: testTemplateId.optional(),
    name: z.string(),
    description: z.string().optional().nullable(),
    category: z.string().optional().nullable(),
    default_assignee_role: z.string().optional().nullable(),
    estimated_duration_hours: z.string().optional().nullable(),
    icon: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    code: z.string(),
    draft_dirty: z.boolean().optional(),
    archived_at: z.date().optional().nullable(),
    archived_by: operatorId.optional().nullable(),
    blueprint: z.string().optional().nullable(),
    blueprint_version: z.number().optional().nullable(),
});
export const testTemplateMutator = z.object({
    id: testTemplateId.optional(),
    name: z.string().optional(),
    description: z.string().optional().nullable(),
    category: z.string().optional().nullable(),
    default_assignee_role: z.string().optional().nullable(),
    estimated_duration_hours: z.string().optional().nullable(),
    icon: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    code: z.string().optional(),
    draft_dirty: z.boolean().optional(),
    archived_at: z.date().optional().nullable(),
    archived_by: operatorId.optional().nullable(),
    blueprint: z.string().optional().nullable(),
    blueprint_version: z.number().optional().nullable(),
});
//# sourceMappingURL=TestTemplate.js.map